import BannerCarousel from './BannerCarousel';

export default BannerCarousel;
